import React, { useCallback, useState } from 'react';
import 'dayjs/locale/fr';
import Grid from '@mui/material/Grid';
import { StaticDatePicker, frFR } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface DateFilterProps {
  onDateChange?: (date: any) => void;
}

const DateFilter = ({ onDateChange = () => {} }: DateFilterProps) => {
  const [selectedDate, setSelectedDate] = useState<any>(Date.now());

  const handleDateChange = useCallback(
    (date: any) => {
      setSelectedDate(date);
      onDateChange(date);
    },
    [onDateChange],
  );

  return (
    <>
      <Grid container>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="fr"
          localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <StaticDatePicker
            disablePast
            displayStaticWrapperAs="desktop"
            value={selectedDate}
            onChange={handleDateChange}
            openTo="day"
            views={['month', 'day']}
          />
        </LocalizationProvider>
      </Grid>
    </>
  );
};

export default DateFilter;
